import React from "react";
 import { useEffect, useState } from "react";
import {Navbar, Nav, Container} from 'react-bootstrap';
import './Navs.css';
import logo from '../../assets/logo.png';

const Navs = ()=>{

    const [ fix, setFix] = useState(false)

    function setFixed() {
      if (window.scrollY >= 30) {
        setFix(true)
      } else {
        setFix(false)
      }
    }
    window.addEventListener("scroll", setFixed)
  
    return (
          <Navbar className={fix ? 'navbar bg-white'  : 'navbar'} fixed="top" expand="lg">
            <Container>
              <Navbar.Brand href="#home">
                <img src={logo} title="logo" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto" >
                  <Nav.Link href="#home">Home</Nav.Link>
                  <Nav.Link href="#about">About As</Nav.Link>
                  <Nav.Link href="#Explore">Explore Food</Nav.Link>
                  <Nav.Link href="#Faq">FAQ</Nav.Link>
                </Nav>
                <Nav>
                  <Nav.Link id="lastnav">+201000000000</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          
    )  
}

export default Navs;  